const MAX_WIDTH = 1200;
const JPEG_QUALITY = 0.82;

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith("image/")) {
      reject(new Error("Please select an image file (JPEG, PNG, GIF, WebP)."));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Failed to read file."));
    reader.readAsDataURL(file);
  });
}

export function resizeImageDataUrl(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      let w = img.width;
      let h = img.height;
      if (w > MAX_WIDTH) {
        h = (h * MAX_WIDTH) / w;
        w = MAX_WIDTH;
      }
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      try {
        const out = canvas.toDataURL("image/jpeg", JPEG_QUALITY);
        resolve(out);
      } catch (e) {
        resolve(dataUrl);
      }
    };
    img.onerror = () => reject(new Error("Failed to load image."));
    img.src = dataUrl;
  });
}

export async function processImageFile(file) {
  const dataUrl = await fileToDataUrl(file);
  return resizeImageDataUrl(dataUrl);
}
